import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const FloatingPaths = ({ position }: { position: number }) => {
  const paths = Array.from({ length: 36 }, (_, i) => {
    const offset = i * 5 * position;
    const yShift = i * 6;
    return {
      id: `path-${position}-${i}`,
      d: `M${70 - offset} ${11 - yShift}C${70 - offset} ${11 - yShift} ${138 - offset} ${416 - yShift} ${602 - offset} ${543 - yShift}C${1066 - offset} ${670 - yShift} ${1134 - offset} ${1075 - yShift} ${1134 - offset} ${1075 - yShift}`,
      width: 0.5 + i * 0.03,
      opacity: 0.1 + i * 0.03,
    };
  });
  return (
    <div className="absolute inset-0 pointer-events-none">
      <svg
        className="w-full h-full"
        viewBox="0 0 1440 400"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
      >
        {paths.map((path) => (
          <motion.path
            key={path.id}
            d={path.d}
            stroke="#339999"
            strokeWidth={path.width}
            strokeOpacity={path.opacity}
            initial={{ pathLength: 0.3, opacity: 0.6 }}
            animate={{
              pathLength: 1,
              opacity: [0.3, 0.6, 0.3],
              pathOffset: [0, 1, 0],
            }}
            transition={{
              duration: 20 + Math.random() * 10,
              repeat: Number.POSITIVE_INFINITY,
              ease: "linear",
            }}
          />
        ))}
      </svg>
    </div>
  );
};

export default function MidPageCta() {
  return (
    <section className="pt-16 md:pt-20 pb-14 md:pb-16 px-6" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e2e8f0', position: 'relative', overflow: 'hidden' }}>
      <div className="absolute inset-0 pointer-events-none z-0">
        <FloatingPaths position={1} />
        <FloatingPaths position={-1} />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="max-w-2xl mx-auto text-center flex flex-col items-center gap-6 relative z-10">
        
        <h2
          className="text-3xl md:text-4xl tracking-tight"
          style={{ color: '#00022e', fontWeight: 900 }}>
          Audit Panic Ends Here

        </h2>

        <p className="text-base md:text-lg" style={{ color: '#64748a' }}>
          Join clinics that walk into audits already ready.
        </p>

        <Link
          to="/get-started"
          className="flex items-center gap-3 px-8 py-4 text-lg font-bold text-white rounded-xl transition-all"
          style={{
            backgroundColor: '#339999',
            boxShadow: '0 0 30px rgba(51,153,153,0.4)'
          }}>
          
          Get Started
          <motion.span
            animate={{ x: [0, 6, 0] }}
            transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
            className="inline-flex">
            
            <ArrowRight className="w-5 h-5" />
          </motion.span>
        </Link>

        <p className="text-xs" style={{ color: '#94a3b8' }}>
          $249/month · or save with annual billing · No setup fees.
        </p>
      </motion.div>
    </section>);

}
